import { __awaiter, __decorate, __metadata, __param } from 'tslib';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { BaseService, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { ConfigService, SpeNAccountCodeProxy, UiPxTokenModule } from '@wlp/ui-px-token';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let TokenCodeService = class TokenCodeService extends BaseService {
    constructor(storage, configService, errorMessageService, speNAccountCodeProxy, formBuilder) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.speNAccountCodeProxy = speNAccountCodeProxy;
        this.formBuilder = formBuilder;
        this.errorMessages = {
            token: [
                { type: 'required', message: 'CASH_OUT.MODAL_TOKEN.MESSAGE.REQUIRED' },
                { type: 'invalid', message: 'CASH_OUT.MODAL_TOKEN.MESSAGE.INVALID' },
            ],
        };
    }
    createFormToken() {
        this.formToken = this.formBuilder.group({
            token: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formToken;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    getToken(uuidWhiteLabel, uuidAccountPayment) {
        return this.speNAccountCodeProxy.getCode(uuidWhiteLabel, uuidAccountPayment);
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
    checkCode(uuidWhiteLabel, uuidAccountPayment, code) {
        return this.speNAccountCodeProxy.checkCode(uuidWhiteLabel, uuidAccountPayment, code);
    }
    checkCodeConsume(uuidWhiteLabel, uuidAccountPayment, code) {
        return this.speNAccountCodeProxy.checkCodeConsume(uuidWhiteLabel, uuidAccountPayment, code);
    }
    confirmToken(uuidWhiteLabel, uuidAccount, token) {
        return __awaiter(this, void 0, void 0, function* () {
            let isValid;
            yield this.checkCode(uuidWhiteLabel, uuidAccount, token)
                .toPromise()
                .then(res => {
                isValid = res.validCode;
            })
                .catch(err => this.getErroMessage(err));
            let response = !!isValid ? isValid : false;
            return Promise.resolve(response);
        });
    }
    /**
     * gera o dado criptografado para o qrcode
     * @param uuidWhiteLabel
     * @param uuidAccountPayment
     * @param uuidOperation
     * @returns
     */
    generateQrcodeCodeToken(uuidWhiteLabel, uuidAccountPayment, uuidOperation) {
        return this.speNAccountCodeProxy.generateQrcodeCodeToken(uuidWhiteLabel, uuidAccountPayment, uuidOperation);
    }
    /**
     * envia o dado que foi lido pelo qrcode
     * @param qrcodeData
     * @returns
     */
    readQrcode(qrcodeData, uuidAccountPayment) {
        return this.speNAccountCodeProxy.readQrcode(qrcodeData, uuidAccountPayment);
    }
    /**
     * este metodo checa se o token foi lido pelo usuario antes. Deve ser aplicado no front com um intervalo
     * de 60 secs.
     * @param qrcodeData
     * @returns
     */
    verifyQrcode(qrcodeData) {
        return this.speNAccountCodeProxy.verifyQrcode(qrcodeData);
    }
};
TokenCodeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        ErrorMessageService,
        SpeNAccountCodeProxy,
        FormBuilder])
], TokenCodeService);

var UiBsTokenModule_1;
let UiBsTokenModule = UiBsTokenModule_1 = class UiBsTokenModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsTokenModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsTokenModule = UiBsTokenModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            IonicModule,
            UiBsUtilModule,
            UiPxTokenModule
        ],
        providers: [TokenCodeService],
        exports: []
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsTokenModule])
], UiBsTokenModule);

class TokenCodeResponse {
}

class CheckCodeResponse {
}

export { CheckCodeResponse, TokenCodeResponse, TokenCodeService, UiBsTokenModule };
//# sourceMappingURL=wlp-ui-bs-token.js.map
